import posthog, { type Properties } from 'posthog-js';
import type { AnalyticsEventName } from '@/analytics/analytics.events';
import { IS_POSTHOG_CONFIGURED } from '@/analytics/posthog.client';

export const track = (event: AnalyticsEventName, properties?: Properties): void => {
  if (!IS_POSTHOG_CONFIGURED) {
    return;
  }
  console.group(`Analytics Event Tracked: ${event}`);
  console.log('Properties:', properties);
  console.groupEnd();
  posthog.capture(event, properties);
};
